
import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';

export class GuardrailsRepository {
  private static instance: GuardrailsRepository;

  /**
   * Singleton pattern - ensure only one instance exists
   */
  public static getInstance(): GuardrailsRepository {
    if (!GuardrailsRepository.instance) {
      GuardrailsRepository.instance = new GuardrailsRepository();
    }
    return GuardrailsRepository.instance;
  }

  public async getAllGuardrails(): Promise<any> {
    return (await api.get(API_ROUTES.GUARDRAILS))?.data;
  }
  
  public async applyGuardrails(payload: any): Promise<any> {
    return (await api.post(API_ROUTES.GUARDRAILS_APPLY, payload))?.data;
  }

  public async updateGuardrails(payload: any): Promise<any> {
    return (await api.post(API_ROUTES.GUARDRAILS_APPLY, payload))?.data;
  }

  public async getGuardrailForDeployedInstance(instanceId: string): Promise<any> {
    return (await api.get(API_ROUTES.GUARDRAILS_DEPLOYED_INSTANCE(instanceId)))?.data;
  }

  public async deleteGuardrailById(id: string): Promise<void> {
    return (await api.delete(API_ROUTES.GUARDRAILS_DELETE(id)))?.data;
  }

  public async getGuardrailById(id: string): Promise<any> {
    return (await api.get(API_ROUTES.GUARDRAILS_BY_ID(id)))?.data;
  }

}
